module.exports = function getResource(label, vars = []) {
    let resources = {
        signIn: 'Ouvrir une session',
        biHeading: 'Résumé Beauty Insider',
        biDesc: 'Voir l’activité, les économies et les avantages',
        biDescJoin: 'Inscrivez-vous dès maintenant pour commencer à économiser et à accumuler des points',
        joinNow: 'S’inscrire',
        rewardsHeading: 'Rewards Bazaar',
        rewardsDesc: 'Réclamez des articles, des échantillons et plus',
        pointsLabel: `Point${vars[0]}`,
        chooseBirthdayGift: 'Choisissez votre cadeau d’anniversaire',
        ccHeading: 'Programme de carte de crédit Sephora',
        ccDesc: 'Gérer les cartes de crédit et les récompenses',
        ccRewardsLabel: 'Récompenses',
        ccApplyNow: 'S’inscrire',
        ordersHeading: 'Commandes',
        ordersDesc: 'Consulter et faire le suivi des commandes en ligne ou à ramasser',
        purchasesHeading: 'Achetez de nouveau',
        purchasesDesc: 'Commandez de nouveau les achats en magasin et en ligne',
        lovesHeading: 'Les favoris',
        lovesDesc: 'Voir les produits conservés',
        recHeading: 'Recommandations des conseillers beauté',
        recDesc: 'Recommandations selon vos visites en magasin',
        reservationsHeading: 'Réservations',
        reservationsDesc: 'Gérez vos services, vos ateliers et vos événements',
        ciqHeading: 'Traits beauté et Color IQ',
        ciqDesc: 'Complétez vos traits beauté pour des recommandations personnalisées',
        accountHeading: 'Paramètres du compte',
        accountDesc: 'Paiement, coordonnées, adresses, mot de passe',
        signOut: 'Se déconnecter',
        flashHeading: 'Programme Flash',
        flashDesc: 'Inscription à la livraison en un ou deux jours illimitée'
    };

    return resources[label];
};
